export default "__VITE_PUBLIC_ASSET__c34272c5__"